import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { injectIntl } from 'react-intl';
import useStyles from './sidebarBig-jss';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import menuIcons from '../../api/images/menuIcons';
import { useLocation } from 'react-router';
import hamburgerIcon from "../../../public/images/btn_icon/ic_hamburger_btn.svg";

const LinkBtn = React.forwardRef((props, ref) => (
  <NavLink to={props?.to} {...props} innerRef={ref} />
));

function MainMenuBig(props) {
  const { classes, cx } = useStyles();
  const {
    open,
    dataMenu,
    openLnbMenu,
    openSubMenu,
    loadTransition,
    toggleDrawerOpen,
  } = props;

  const [selectedMenu, setSelectedMenu] = useState([]);
  const [gnbMenuName, setGnbMenuName] = useState('');
  const [menuLoaded, setMenuLoaded] = useState(true);
  const [currentMenu, setCurrentMenu] = useState([]);
  const [expandedMenus, setExpandedMenus] = useState([]);
  const [selectedMainMenu, setSelectedMainMenu] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation(); // 현재 경로를 추적하기 위해 useLocation 훅 사용

  const categoryLoaded = useSelector((state) => state.authReducer.loggedIn);

  // 아이콘 SVG 가져오는 함수
  const getIconSvg = (iconType, activated) => {
    let iconImg;
    let isWalletManagement = false;
    let onClickHandler = null;

    switch (iconType) {
      case 'walletManagement':
        isWalletManagement = true;
        if (activated) {
          iconImg = menuIcons?.walletActive;
        } else {
          iconImg = menuIcons?.walletDefault;
        }
        break;
      case 'appManagement':
        if (activated) {
          iconImg = menuIcons?.appActive;
        } else {
          iconImg = menuIcons?.appDefault;
        }
        break;
      case 'eventManagement':
        if (activated) {
          iconImg = menuIcons?.eventActive;
        } else {
          iconImg = menuIcons?.eventDefault;
        }
        break;
      case 'userManagement':
        if (activated) {
          iconImg = menuIcons?.userActive;
        } else {
          iconImg = menuIcons?.userDefault;
        }
        break;
      case 'logManagement':
        if (activated) {
          iconImg = menuIcons?.logActive;
        } else {
          iconImg = menuIcons?.logDefault;
        }
        break;
      case 'monitoring':
        if (activated) {
          iconImg = menuIcons?.monitoringActive;
        } else {
          iconImg = menuIcons?.monitoringDefault;
        }

        // onClickHandler = () => {
        //   window.open('https://console.dfinery.io/', '_blank');
        // };
        break;
      case 'backofficeManagement':
        if (activated) {
          iconImg = menuIcons?.backofficeActive;
        } else {
          iconImg = menuIcons?.backofficeDefault;
        }
        break;
      case 'setting':
        if (activated) {
          iconImg = menuIcons?.settingActive;
        } else {
          iconImg = menuIcons?.settingDefault;
        }
        break;
      default:
        iconImg = menuIcons?.defaultIcon;
        break;
    }
    const icon = <img src={iconImg} alt={iconType} />;
    return (
      <div
        className={isWalletManagement ? 'menuIconDiv wallet' : 'menuIconDiv'}
        onClick={onClickHandler}
        title={icon.props.alt}
      >
        {icon}
      </div>
    );
  };

  // 메뉴 로드 처리 함수
  const handleLoadMenu = (menu, key, name) => {
    setSelectedMenu(menu);
    setMenuLoaded(false);
    openLnbMenu(key);
    setGnbMenuName(name);
    setSelectedMainMenu(key); // 선택된 메인 메뉴 업데이트

    setTimeout(() => {
      setMenuLoaded(true);
    }, 100);
  };

  useEffect(() => {
    const pathName = location?.pathname;

    if (categoryLoaded) {
      setMenuLoaded(false);

      const initialExpandedMenus = dataMenu?.flatMap(item =>
        item?.child ? [item?.key, ...item?.child?.map(child => child?.key)] : [item?.key]
      );
      setExpandedMenus(initialExpandedMenus);

      // 현재 경로에 해당하는 메뉴 찾기
      let foundMenu = false;
      dataMenu?.forEach((item) => {
        if (item?.child) {
          item?.child?.forEach((lnb) => {
            if (lnb?.child) {
              lnb?.child?.forEach((sub) => {
                if (pathName?.includes(sub.link)) {
                  handleLoadMenu(item?.child, item?.key, item?.name);
                  setSelectedMenu(item?.child);
                  openSubMenu(lnb?.key, item?.key);
                  setCurrentMenu(sub);
                  setMenuLoaded(true);
                  foundMenu = true;
                }
              });
            } else if (pathName?.includes(lnb?.link)) {
              handleLoadMenu(item?.child, item?.key, item?.name);
              setSelectedMenu(item?.child);
              openLnbMenu(item?.key);
              setCurrentMenu(lnb);
              setMenuLoaded(true);
              foundMenu = true;
            }
          });
        }
      });

      if (!foundMenu) {
        // 경로에 해당하는 메뉴를 찾지 못했을 경우, 선택된 메뉴 초기화
        setSelectedMainMenu('');
        setSelectedMenu([]);
        setCurrentMenu([]);
      }
    }
  }, [location?.pathname, dataMenu, categoryLoaded]);

  const handleClick = () => {
    toggleDrawerOpen();
    loadTransition(false);
  };

  // 메뉴 아이템 활성화 여부 확인
  const activeMenu = (key, child) => {
    if (selectedMenu.length < 1) {
      return open.indexOf(key) > -1;
    }
    return child === selectedMenu;
  };

  // 메인 메뉴 렌더링
  const getMenus = (menuArray) => {

    const hamburgerBtn = (
        <div style={{width : "32px",cursor : "pointer", display : "flex", alignItems : "center", justifyContent : "center"}}
             onClick={() => {setIsOpen(!isOpen)}}>
          <img src={hamburgerIcon} alt=""/>
        </div>
    )

    return [hamburgerBtn].concat(menuArray?.map((item, index) => {
      if (item?.key === 'menu_levels') return null;

      const isActive = selectedMainMenu === item?.key;

      if (item?.child) {
        return (
            <div
                key={index?.toString()}
                onClick={() => {
                  setIsOpen(true);
                  handleLoadMenu(item?.child, item?.key, item?.name)
                }}
                className={cx(
                    classes?.menuHead,
                    isActive ? classes?.active : '',
                )}
            >
              {getIconSvg(item?.icon, isActive)}
              <span className={classes?.text}>{item?.name}</span>
            </div>
        );
      }

      return (
          <div
              key={index?.toString()}
              className={cx(
                  classes?.menuHead,
                  expandedMenus.includes(item?.key) ? classes?.active : '',
              )}
          >
            {getIconSvg(item?.icon, activeMenu(item?.key, item?.child))}
            <span className={classes?.text}>{item?.name}</span>
          </div>
      );
    }));
  };


  // 자식 메뉴 렌더링
  const getChildMenu = (menuArray) => menuArray
      .filter((x) => x.key)
      .map((item, index) => {
        if (item?.child) {
          return (
              <div key={index?.toString()}
              >
                <ListItem
                    className={cx(
                        classes?.head,
                        item?.icon ? classes?.iconed : '',
                expandedMenus.includes(item?.key) ? classes?.opened : '',
              )}
              onClick={() => {
                openSubMenu(item?.key, item?.keyParent);
                setExpandedMenus(prev =>
                  prev.includes(item?.key)
                    ? prev.filter(key => key !== item?.key)
                    : [...prev, item?.key]
                );
              }}
            >
              {item?.icon && (
                <ListItemIcon className={classes?.icon}>
                  {expandedMenus.includes(item?.key)}
                </ListItemIcon>
              )}
              <ListItemText
                classes={{ primary: classes?.primary }}
                primary={item?.name}
              />
              {/* {!item?.linkParent && ( */}
              <span>
                {expandedMenus.includes(item?.key) ? <ExpandLess /> : <ExpandMore />}
              </span>
              {/* )} */}
            </ListItem>
            {/* {!item?.linkParent && ( */}
            <Collapse
              component="div"
              className={cx(
                classes?.nolist,
                item?.keyParent ? classes?.child : '',
              )}
              in={expandedMenus.includes(item?.key)}
              timeout="auto"
              unmountOnExit
            >
              <List className={classes?.dense} component="nav" dense>
                {getChildMenu(item?.child, 'key')}
              </List>
            </Collapse>
            {/* )} */}
          </div>
        );
      }
      return (
        <ListItem
          key={index?.toString()}
          exact
          className={classes?.nested}
          activeClassName={classes?.active}
          component={LinkBtn}
          to={item?.link}
          onClick={() => handleClick()}
        >
          <ListItemText
            classes={{ primary: classes?.primary }}
            primary={item?.name}
          />
        </ListItem>
      );
    });

  // 자식 메뉴 렌더링 함수
  const renderChildMenu = () => {
    if (selectedMenu.length < 1) {
      return (
        <List dense className={classes?.fixedWrap}>
          {currentMenu?.length > 0 ? getChildMenu(currentMenu[0]?.child) : ''}
        </List>
      );
    }

    return (
      <List
        dense
        className={cx(
          classes?.fixedWrap,
          classes?.childMenuWrap,
          menuLoaded && classes?.menuLoaded,
        )}
      >
        <ListSubheader
          disableSticky
          key={gnbMenuName}
          component="div"
          className={classes?.title}
        >
          {gnbMenuName}
        </ListSubheader>
        {getChildMenu(selectedMenu)}
      </List>
    );
  };

  return (
    <div className={classes?.bigSidebar}>
      <nav className={classes?.category}>
        <div className={classes?.fixedWrap}>
          {getMenus(dataMenu)}
        </div>
      </nav>
      <nav
          style={{ width: isOpen ? "260px" : "60px", transition: "all 0.3s ease-in-out" }}
          className={cx(classes?.listMenu)}>{renderChildMenu()}</nav>
    </div>
  );
}

MainMenuBig.propTypes = {
  userAttr: PropTypes?.object.isRequired,
  open: PropTypes?.array.isRequired,
  dataMenu: PropTypes?.array.isRequired,
  openLnbMenu: PropTypes?.func.isRequired,
  openSubMenu: PropTypes?.func.isRequired,
  loadTransition: PropTypes?.func.isRequired,
  drawerPaper: PropTypes?.bool.isRequired,
  toggleDrawerOpen: PropTypes?.func,
  intl: PropTypes?.object.isRequired,
};

MainMenuBig.defaultProps = {
  toggleDrawerOpen: () => {},
};

const openLnbAction = (key) => ({ type: 'OPEN_SUBMENU', key });
const openAction = (key, keyParent) => ({
  type: 'OPEN_SUBMENU',
  key,
  keyParent,
});

const mapStateToProps = (state) => ({
  open: state?.ui?.subMenuOpen,
});

const mapDispatchToProps = (dispatch) => ({
  openSubMenu: bindActionCreators(openAction, dispatch),
  openLnbMenu: bindActionCreators(openLnbAction, dispatch),
});

const MainMenuBigMapped = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainMenuBig);

export default injectIntl(MainMenuBigMapped);
